export default "/images/4cf0bf2d696bf5623d81d4077091ecd9.avif";